<template>
  <div id="navBar">
    <b-navbar toggleable="lg" type="dark" variant="dark" class="sticky-top">
      <b-navbar-brand href="#">Flutr Butterfly Repository</b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>



        <b-navbar-nav class="ml-auto">   
          <b-nav-item id="location" disabled>Location: {{this.$router.currentRoute['name']}}</b-nav-item>
          <b-nav-item @click="goHome()"  id="homeNav"><b-icon-house-fill></b-icon-house-fill> Home</b-nav-item>
          <b-nav-item @click="goStats()" id="statsNav"><b-icon-graph-up></b-icon-graph-up> Statistics</b-nav-item>
          <b-nav-item @click="goButterflySearch()"><b-icon-search></b-icon-search> Find Butterfly</b-nav-item>
          <b-nav-item @click="goButterlfyGallery()" id="butterlfyGalleryNav"><b-icon-images></b-icon-images> Butterlfy Gallery</b-nav-item>
          <b-nav-item @click="goPlantGallery()" id="butterlfyPlantNav"><b-icon-images></b-icon-images> Plant Gallery</b-nav-item>
          <div v-if="!kiosk">
            <b-nav-item-dropdown v-if="activeUser!=null" :text="activeUser.name" right>
            <b-dropdown-item @click="goExcel()"><b-icon-document-spreadsheet></b-icon-document-spreadsheet> Excel Import/Export</b-dropdown-item>    
            <b-dropdown-item @click="goShipments()"><b-icon-pencil></b-icon-pencil> Modify Shipments</b-dropdown-item>
            <b-dropdown-item @click="goButterflies()"><b-icon-pencil></b-icon-pencil> Modify Butterflies</b-dropdown-item>    
            <b-dropdown-item @click="goPlants()"><b-icon-pencil></b-icon-pencil> Modify Plants</b-dropdown-item>
            <b-dropdown-item @click="goShipmentSearch()"> <b-icon-search></b-icon-search> Find Shipments</b-dropdown-item>  
            <b-dropdown-item @click="goCustomize()"> <b-icon-person></b-icon-person> Customize</b-dropdown-item>  
            <b-dropdown-item @click="kioskView()"> <b-icon-tv></b-icon-tv> Kiosk View</b-dropdown-item>  
            <b-dropdown-item href="#" @click.prevent="login" v-if="!activeUser">Login</b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="logout" v-else><b-icon-x></b-icon-x> Logout</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item href="#" @click.prevent="login" v-if="!activeUser"><b-icon-check-box></b-icon-check-box> Login</b-nav-item>
          </div>

        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view></router-view>
  </div>
</template>



<style>
#homeNav, #statsNav, #shipmentsNav, #butterflyNav {
  border-radius: 10px;
}

.noselect {
  -webkit-touch-callout: none; 
  -webkit-user-select: none; 
  -khtml-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none; 
}
</style>

<script>
import { userRef } from '../firebase'
export default {
  name: 'navBar',
  data () {
    return {
      activeUser: null,
      users: [],
      kiosk: false
    }
  },
  async created () {
    await this.refreshActiveUser()
  },
  watch: {
    '$route': 'refreshActiveUser'
  },
  firebase: {
    users: userRef
  },
  methods: {
    login () {
      this.$auth.loginRedirect()
    },
    async refreshActiveUser () {
      this.activeUser = await this.$auth.getUser()
    },
    async logout () {
      await this.$auth.logout()
      await this.refreshActiveUser()
      if(this.$router.currentRoute['path']!='/'){
        this.$router.push('/')
      } 
    },
    goStats(){
      if(this.$router.currentRoute['path']!='/stats'){
        this.$router.push('/stats')
      }    
    },
    goHome(){
      if(this.$router.currentRoute['path']!='/'){
        this.$router.push('/')
      } 
    },
    goButterflies(){
      if(this.$router.currentRoute['path']!='/butterflies'){
        this.$router.push('/butterflies')
      } 
    },
    goPlants(){
      if(this.$router.currentRoute['path']!='/plants'){
        this.$router.push('/plants')
      } 
    },
    goShipments(){
      if(this.$router.currentRoute['path']!='/shipments'){
        this.$router.push('/shipments')
      } 
    },
    goButterlfyGallery(){
      if(this.$router.currentRoute['path']!='/gallery/butterflies'){
        this.$router.push('/gallery/butterflies')
      } 
    },
    goPlantGallery(){
      if(this.$router.currentRoute['path']!='/gallery/plants'){
        this.$router.push('/gallery/plants')
      } 
    },
    goExcel(){
      if(this.$router.currentRoute['path']!='/excel'){
        this.$router.push('/excel')
      } 
    },
    goShipmentSearch(){
      if(this.$router.currentRoute['path']!='/search/shipment'){
        this.$router.push('/search/shipment')
      } 
    },
    goButterflySearch(){
      if(this.$router.currentRoute['path']!='/search/butterfly'){
        this.$router.push('/search/butterfly')
      } 
    },
    goCustomize(){
      var found = false;
      for(let i =0; i<this.users.length; i++){
        if(this.users[i].user == this.activeUser.name){
          found = true;
        }
      }
      if(!found){
        userRef.push({title: '', titleText: '', note: '', other: '', user: this.activeUser.name});
      }
      if(this.$router.currentRoute['path']!='/customize'){
        this.$router.push('/customize')
      } 
    },
    kioskView(){
      this.kiosk = true;
    }
  }
}
</script>
